<div class="offers">
  <!--
  <h3> Rendez vous ({{providerOffers == null ? 0 : providerOffers!.length}})</h3>
  <button *ngIf="(appointments == undefined || appointments.length === 0 )"
    class="cta-button"  mat-button (click)="openAppointmentDialog('', undefined);$event.stopPropagation()">
    Nouvelle<mat-icon>add</mat-icon>
  </button> -->

  @if (enableNew) {
    <button mat-button class="cta-button-{{businessLine!.toLowerCase()}}" (click)="openProviderOfferDialog(carId, '', businessLine);$event.stopPropagation()">
      Nouvelle<mat-icon>add</mat-icon>
    </button>
  }

  @if (providerOffers == undefined || providerOffers.length === 0) {
    <h6>
      Aucune offre en cours
    </h6>
  }

  @if (!(providerOffers == undefined || providerOffers.length === 0 )) {
    <div class="offer-list">
      @for (offer of providerOffers; track offer; let i = $index) {
        <div class="offer">
          <div class="summary">
            <!-- <b>[{{ (conversation.participants[0] === null)? 'EXT' : conversation.participants[0] }}]</b> -->
            @if (objectSource===ObjectSource.DEALER) {
              <h4> {{offer.make}} {{offer.model}} {{offer.version}} </h4>
            }
            <h4 class="summary-details"><mat-icon>location_on</mat-icon> {{offer.city}} - {{offer.country}} </h4>
            <h4 class="summary-details"><mat-icon>person</mat-icon> Vendeur: <b>{{offer.providerName}}</b></h4>
            <br />
            <button  class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="goToOfferPage(offer.offerId, offer.businessLine);$event.stopPropagation()">
              Aller à l'offre<mat-icon>open_in_new</mat-icon>
            </button>
          </div>
          <div class="content">
            @if (offer.businessLine === CarBusinessLine.BUY) {
              <span>
                <h4>
                  {{moneyFormat(""+offer.buyPrice.amount)}} {{offer.buyPrice.currency}}
                  <button style="display: inline;" matButton class="simple-button-buy"  mat-button (click)="openPriceHistoryDialog(offer.buyPriceHistory, offer.businessLine);$event.stopPropagation()">
                    <mat-icon>timeline</mat-icon>
                  </button>
                </h4>
              </span>
            }
            @if (offer.businessLine === CarBusinessLine.RENT) {
              <span>
                <h4> {{moneyFormat(""+offer.rentDayRate.amount)}} {{offer.rentDayRate.currency}}/J
                  <button style="display: inline;" matButton class="simple-button-rent"  mat-button (click)="openPriceHistoryDialog(offer.rentDayRateHistory, offer.businessLine);$event.stopPropagation()">
                    <mat-icon>timeline</mat-icon>
                  </button>
                </h4>
                <h6>
                  Assurance: {{moneyFormat(""+offer.rentInsuranceDayRate.amount)}} {{offer.rentInsuranceDayRate.currency}}/J
                  <button style="display: inline;" matButton class="simple-button-rent"  mat-button (click)="openPriceHistoryDialog(offer.rentInsuranceDayRateHistory, offer.businessLine);$event.stopPropagation()">
                    <mat-icon>timeline</mat-icon>
                  </button> <br />
                  Chauffeur:  {{moneyFormat(""+offer.rentDriverDayRate.amount)}} {{offer.rentDriverDayRate.currency}}/J
                  <button style="display: inline;" matButton class="simple-button-rent"  mat-button (click)="openPriceHistoryDialog(offer.rentDriverDayRateHistory, offer.businessLine);$event.stopPropagation()">
                    <mat-icon>timeline</mat-icon>
                  </button>
                </h6>
              </span>
            }
            <h6> Titre: {{offer.offerTitle}}</h6>
            <h6> Description: {{offer.offerDescription}}</h6>
            <h6> Date debut: {{dateFormat(offer.offerStartDate)}}</h6>
            <h6> Date fin: {{dateFormat(offer.offerEndDate)}}</h6>
            <!--
            <h6> Date création: {{dateFormat(offer.created)}}</h6>
            <h6> Dernière mise a jour: {{dateFormat(offer.lastUpdated)}}</h6>  -->
            <div class="action-buttons">
              @if (!(offer.offerPosted)) {
                <button
                  class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="deleteOffer(offer.carId, offer.offerId, offer.businessLine);$event.stopPropagation()">
                  <mat-icon>delete</mat-icon>
                </button>
              }
              @if (!(offer.offerClosed)) {
                <button
                  class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="openProviderOfferDialog(offer.carId, offer.offerId, offer.businessLine);$event.stopPropagation()">
                  Editer <mat-icon>edit</mat-icon>
                </button>
              }
              <button [disabled]="offer.offerClosed"
                class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="toggleOfferPostedStatus(offer.carId, offer.offerId, offer.businessLine);$event.stopPropagation()">
                {{ offer.offerPosted ? 'Dépublier' : 'Publier' }} <mat-icon [style.color]="! offer.offerPosted ? '#008000':'#ff0000'"> {{ offer.offerPosted  ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <button
                class="simple-button-{{offer.businessLine.toLowerCase()}}"  mat-button (click)="toggleOfferClosedStatus(offer.carId, offer.offerId, offer.businessLine);$event.stopPropagation()">
                {{ offer.offerClosed ? 'Ouvrir' : 'Fermer' }} <mat-icon [style.color]="offer.offerClosed ? '#008000':'#ff0000'"> {{ offer.offerClosed  ? 'public_off' : 'public' }}</mat-icon>
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>